import { useState } from 'react';
import { config } from '../../common/global/config';
import Logo from '../assets/images/Logo-Benefit-Edenred.svg';
import AppStoreButton from '../assets/images/maintenance/app-store-download-button.svg';
import EarthIcon from '../assets/images/maintenance/footer-earth-icon-lang-selector.svg';
import GooglePlayButton from '../assets/images/maintenance/google-play-download-button.svg';
import BlueCircle from '../assets/images/maintenance/right-section-blue-circle.svg';
import BlueLongRectangle from '../assets/images/maintenance/right-section-long-blue-rectangle.svg';
import MainPhoto from '../assets/images/maintenance/right-section-main-photo.svg';
import PinkRectangle from '../assets/images/maintenance/right-section-pink-rectangle.svg';
import BlueShortRectangle from '../assets/images/maintenance/right-section-short-blue-rectangle.svg';
import resources from '../../apps/benefit/resources/types.json';

export const MaintenanceApp = () => {
  const [lang, setLang] = useState('ro');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const changeLanguage = (selectedLanguage: string) => {
    setLang(selectedLanguage);
    setIsDropdownOpen(false);
  };

  const translations: { [lang: string]: { [key: string]: string } } = {
    ro: {
      title: resources.emptyState.underMaintenance.title,
      text: resources.emptyState.underMaintenance.text,
      action: resources.emptyState.underMaintenance.action,
      aNPCLink: resources.footer.aNPCLink,
    },
    en: {
      title: 'We perform maintenance activities',
      text: "We are working on the platform to improve it, we apologize for any inconvenience. We'll be back soon!",
      action: 'Have you tried the Benefit app?',
      aNPCLink: 'https://anpc.ro/ce-este-sal/',
    },
  };
  const translate = (code: string) => {
    return translations[lang][code];
  };

  return (
    <div className="maintenance-page">
      <section className="section-main">
        <section className="section-left">
          <div className="section-content">
            <img
              src={Logo}
              alt="Benefit Edenred Logo"
              className="benefit-logo"
            />
            <div className="empty-state es-maintenance-page">
              <h3>{translate('title')}</h3>
              <p>{translate('text')}</p>
              <p>{translate('action')}</p>
              <div className="app-buttons">
                <a
                  href="https://apps.apple.com/ro/app/edenred-benefit/id1544967965?l=ro"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={AppStoreButton} alt="Download from App Store" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.edenred.ro.benefitMobileApp&hl=ro&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={GooglePlayButton} alt="Download from Google Play" />
                </a>
              </div>
            </div>
          </div>

          <footer className="maintenance-footer">
            <span className="footer-language">
              <button
                id="language-selector"
                className={`language-selector ${isDropdownOpen ? 'open' : ''}`}
                aria-expanded={isDropdownOpen}
                onClick={toggleDropdown}
              >
                <img
                  src={EarthIcon}
                  alt="Language Icon"
                  className="language-icon"
                />
                {lang.toLocaleUpperCase()}
                <div
                  className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}
                >
                  <ul>
                    {config.languages.map((language: string) => (
                      <li key={language.toLocaleUpperCase()}>
                        <button
                          key={language}
                          onClick={() => changeLanguage(language)}
                        >
                          {language.toLocaleUpperCase()}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </button>
            </span>
            <span className="footer-link">
              <a
                href={translate('aNPCLink')}
                target="_blank"
                rel="noopener noreferrer"
              >
                ANPC
              </a>
            </span>
          </footer>
        </section>

        <section className="section-right">
          <img
            src={BlueLongRectangle}
            alt="Blue Long Rectangle"
            className="blue-long-rectangle"
          />
          <img src={BlueCircle} alt="Blue Circle" className="blue-circle" />
          <img
            src={BlueShortRectangle}
            alt="Blue Short Rectangle"
            className="blue-short-rectangle"
          />
          <img
            src={PinkRectangle}
            alt="Pink Rectangle"
            className="pink-rectangle"
          />

          <div className="right-section-image">
            <img src={MainPhoto} alt="Main Photo" />
          </div>
        </section>
      </section>
    </div>
  );
};
